import script from "./model-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./model-list.vue?vue&type=script&setup=true&lang=ts"

import "./model-list.vue?vue&type=style&index=0&id=89ed5b2e&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89ed5b2e"]])

export default __exports__